const baseId = 'app4zRlCbgnEsm8Up'
const apiKey = 'patFVJcRuLHnGd9RU.584bdce2ef3bb4c65b91cd939fc2f3d91e2ac7ddf798a101e97bc3bfac32d9b5'

const getBanner = async () => {
  try {
    const apiUrl = `https://api.airtable.com/v0/${baseId}/Banner?sort%5B0%5D%5Bfield%5D=orderID&sort%5B0%5D%5Bdirection%5D=asc`;
    const response = await fetch(apiUrl, {
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    });
    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.log('banner error', error)
    // console.error(error);
  }
};

const getQA = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/Q%26A?sort%5B0%5D%5Bfield%5D=orderID&sort%5B0%5D%5Bdirection%5D=asc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getNews = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/News?sort%5B0%5D%5Bfield%5D=Date&sort%5B0%5D%5Bdirection%5D=desc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
      // console.log(data)
     
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  const getMemberNews = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/News?filterByFormula=Type%3D%22%23Members+News%22&sort%5B0%5D%5Bfield%5D=Date&sort%5B0%5D%5Bdirection%5D=desc
      `;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
      // console.log(data)
     
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  
  const getPressUpdate = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/News?filterByFormula=Type%3D%22%23Press+Update%22&sort%5B0%5D%5Bfield%5D=Date&sort%5B0%5D%5Bdirection%5D=desc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
      // console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  const getNewestPressUpdate = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/app4zRlCbgnEsm8Up/News?filterByFormula=Type+%3D+%22%23Press+Update%22&maxRecords=3&sort%5B0%5D%5Bfield%5D=Date&sort%5B0%5D%5Bdirection%5D=desc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getSpeakers = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/Speakers?sort%5B0%5D%5Bfield%5D=orderID&sort%5B0%5D%5Bdirection%5D=asc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getEvents = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/app4zRlCbgnEsm8Up/Events?sort%5B0%5D%5Bfield%5D=Date&sort%5B0%5D%5Bdirection%5D=desc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getVolunteers = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/Volunteers?sort%5B0%5D%5Bfield%5D=orderID&sort%5B0%5D%5Bdirection%5D=asc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getBoardMembers = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/BoardMembers?sort%5B0%5D%5Bfield%5D=Order&sort%5B0%5D%5Bdirection%5D=asc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getExecutiveMember= async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/ExecutiveTeam?sort%5B0%5D%5Bfield%5D=Order&sort%5B0%5D%5Bdirection%5D=asc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  
  const getSponsors = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/Sponsors?sort%5B0%5D%5Bfield%5D=orderID&sort%5B0%5D%5Bdirection%5D=asc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  const getPartners = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/Partners?sort%5B0%5D%5Bfield%5D=orderID&sort%5B0%5D%5Bdirection%5D=asc`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getApplications = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/SponsorApplication`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getContactInfo = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/ContactInformation`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getNewFeature = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/NewFeatureUpdate`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getYoutubeLink = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/YoutubeLink`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      return []
      console.error(error);
    }
  };

  const getRegisterLink = async () => {
    try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/YoutubeLink`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const data = await response.json();
    //   console.log(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getBoardMemberById = async (desiredValue) => {
    try {
        const apiUrl = `https://api.airtable.com/v0/${baseId}/BoardMembers?filterByFormula=(order='${desiredValue}')`;
        const response = await fetch(apiUrl, {
            headers: {
                Authorization: `Bearer ${apiKey}`,
            },
        });
        const data = await response.json();
        // console.log(data);
        return data;
    } catch (error) {
        console.error(error);
    }
};


const getExecutiveTeamById = async (desiredValue) => {
  try {
      const apiUrl = `https://api.airtable.com/v0/${baseId}/ExecutiveTeam?filterByFormula=(order='${desiredValue}')`;
      const response = await fetch(apiUrl, {
          headers: {
              Authorization: `Bearer ${apiKey}`,
          },
      });
      const data = await response.json();
      // console.log(data);
      return data;
  } catch (error) {
      console.error(error);
  }
};

  
export {
    getBanner,
    getQA,
    getNews,
    getSpeakers,
    getEvents,
    getVolunteers,
    getBoardMembers,
    getSponsors,
    getApplications,
    getContactInfo,
    getNewFeature,
    getMemberNews,
    getPressUpdate,
    getPartners,
    getNewestPressUpdate,
    getYoutubeLink,
    getBoardMemberById,
    getExecutiveMember, 
    getExecutiveTeamById,
    getRegisterLink


}
